import { render } from "./Fines.vue?vue&type=template&id=160ad4c4&scoped=true"
import script from "./Fines.vue?vue&type=script&lang=js"
export * from "./Fines.vue?vue&type=script&lang=js"

import "./Fines.vue?vue&type=style&index=0&id=160ad4c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160ad4c4"]])

export default __exports__